import React from 'react';
import { UserProfilePage } from 'pages/admin/users/user/profilePage';

export const WarehouseProfile: React.FC = () => {
  return <UserProfilePage storageUserIdentifier={'warehouse_userId'} />;
};
